// extracted by mini-css-extract-plugin
module.exports = {"selectedItemBox":"SelectedItem_selectedItemBox__3G8ol","selectedSummary":"SelectedItem_selectedSummary__3SwgP"};